export default __webpack_public_path__ + "static/media/ace_of_swords.06839f72.png";